import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import Career from 'wwg-utilities/dist/collections/career';
import CareerSeeker from 'wwg-utilities/dist/collections/career-seeker';
import Program from 'wwg-utilities/dist/collections/program';
import getSalaryDataForLocationRequest from '../api/getSalaryForLocationRequest';

const useLocalSalaryData = (
  onetCode: string,
  item: Program | Career,
  seeker: CareerSeeker | null,
  regionLocation: string,
) => {
  const [location, setLocation] = useState('United States');
  useEffect(() => {
    if (seeker) {
      setLocation((seeker as any)?.zipcodeLocation);
    } else {
      setLocation(regionLocation);
    }
  }, [seeker, regionLocation]);

  const { data: wageData } = useQuery([location, onetCode], () => {
    if (location && onetCode) {
      return getSalaryDataForLocationRequest(location, onetCode);
    }
    return null;
  });

  const medianAnnualSalary =
    wageData?.medianAnnualSalary?.value ||
    (item as Career)?.wageData?.medianAnnualSalary;
  const medianHourlyWage =
    wageData?.medianHourlyWage?.value ||
    (item as Career)?.wageData?.medianHourlyWage;
  const entryAnnualSalary =
    wageData?.entryAnnualSalary?.value ||
    (item as Career)?.wageData?.entryAnnualSalary;
  const entryHourlyWage =
    wageData?.entryHourlyWage?.value ||
    (item as Career)?.wageData?.entryHourlyWage;
  const highHourlyWage =
    wageData?.highHourlyWage?.value ||
    (item as Career)?.wageData?.highHourlyWage;
  const highAnnualSalary =
    wageData?.highAnnualSalary?.value ||
    (item as Career)?.wageData?.highAnnualSalary;

  return {
    medianAnnualSalary,
    entryAnnualSalary,
    entryHourlyWage,
    medianHourlyWage,
    highAnnualSalary,
    highHourlyWage,
  };
};

export default useLocalSalaryData;
